document.addEventListener('DOMContentLoaded', function () {
    const siteHeader = document.querySelector('.site-header')
    const siteLogo = document.querySelector('.logo-wrapper')
    const scrolledSiteLogo = document.querySelector('.scrolled-logo-wrapper')

    // Check if the site header is sticky
    const observer = new IntersectionObserver(
        ([e]) => {
            if (siteHeader) {
                siteHeader.classList.toggle('scrolled', e.intersectionRatio < 1)
            }
        },
        {
            threshold: [1],
        }
    )
    observer.observe(siteHeader)

    // Add taxonomy name and link on load
    const menuParentItems = document.querySelectorAll('.menu-item-has-children')
    menuParentItems.forEach((menuParentItem) => {
        const taxName = menuParentItem.querySelector('.menu-item-title').textContent
        const taxLink = menuParentItem.querySelector('a').href
        const catTitles = menuParentItem.querySelectorAll(`.sub-cat-title`)
        const catLinks = menuParentItem.querySelectorAll(`.sub-cat-link`)

        catTitles.forEach((catTitle) => {
            catTitle.innerHTML = taxName
        })

        catLinks.forEach((catLink) => {
            catLink.href = taxLink
        })
    })
})
